@if (showHeader()) {
  <div class="tt-compare-description_header" [class.tt-compare-description_header--compare]="compareMode()">
    @if (compareMode()) {
      <div class="tt-compare-description_header-local">
        @if (mergeConflictStatus() !== 'conflict') {
          {{ 'SingleGuidelineManager.ImportedGuideline.Editor.LocalDescription' | transloco }}
        } @else {
          <button ttButton [size]="'xSmall'" [variant]="'outline'" (click)="handleAcceptLocalClicked()">
            {{ 'SingleGuidelineManager.ImportedGuideline.Editor.TakeLocalChanges' | transloco }}
          </button>
        }
      </div>
      <div class="tt-compare-description_divider">
        @if (hasLocalChanges() && mergeConflictStatus() !== 'conflict') {
          <button aria-label="Revert to original'">
            <mat-icon
              class="tt-compare-description_divider-icon"
              data-testid="compare-description_revert-button"
              [icon]="'chevrons-left'"
              [iconSize]="14"
              [ttTooltip]="'SingleGuidelineManager.ImportedGuideline.Editor.RevertToOriginalTooltip' | transloco"
              (click)="revertLocalDescription()" />
          </button>
        }
      </div>
      <div class="tt-compare-description_header-original">
        @if (mergeConflictStatus() !== 'conflict') {
          {{ 'SingleGuidelineManager.ImportedGuideline.Editor.OriginalDescription' | transloco }}
        } @else {
          <button ttButton [size]="'xSmall'" [variant]="'outline'" (click)="handleAcceptOriginalClicked()">
            {{ 'SingleGuidelineManager.ImportedGuideline.Editor.TakeOriginalChanges' | transloco }}
          </button>

          <common-chip class="tt-smartbook_merge-conflict" [variant]="'' + 'inactive'">
            {{ 'GuidelineUpdateTag.MergeConflict' | transloco }}
          </common-chip>
        }
      </div>
    }

    @if (mergeConflictStatus() === 'resolved') {
      <common-chip class="tt-compare-description_header-resolved" [clickable]="true" [ttMenuTriggerFor]="menu" [variant]="'inprogress'">
        {{ 'GuidelineUpdateTag.MergeResolved' | transloco }}
      </common-chip>
    }
  </div>
}
<div class="tt-compare-description">
  @let content = local() === undefined || local() === null ? (original() ?? '') : local();

  @if (content !== undefined && editMode()) {
    <span class="tt-compare-description_local">
      <common-rich-text-editor
        class="tt-compare-description_local-input"
        data-testid="compare-description_local-content"
        [allowReferenceRemovalHandling]="true"
        [editorContent]="content"
        [id]="id()"
        [references]="references()"
        [ttAutofocus]="true"
        (editorContentChange)="handleLocalDescriptionChanged($event)"
        (referencesChange)="handleLocalDescriptionReferencesChanged($event)" />
    </span>
  } @else {
    <span class="tt-compare-description_local">
      <common-rich-text-view
        class="tt-compare-description_local-view"
        ttCommentableText
        [content]="content"
        [elementId]="`${id()}-text`"
        [placeholder]="'SingleGuidelineManager.ImportedGuideline.Editor.NoDescription'"
        [references]="references()"
        [widgetId]="id()" />
    </span>
  }

  @if (compareMode()) {
    <div class="tt-compare-description_divider"></div>
    <span class="tt-compare-description_original">
      <common-rich-text-view
        class="tt-compare-description_original"
        data-testid="compare-description_original-content"
        [content]="original() ?? ''"
        [placeholder]="'SingleGuidelineManager.ImportedGuideline.Editor.NoDescription'" />
    </span>
  }
</div>

<tt-menu #menu>
  <button ttMenuItem (click)="conflictUnresolved.emit()">
    {{ 'SingleGuidelineManager.ImportedGuideline.Editor.UndoResolve' | transloco }}
  </button>
</tt-menu>
